module.exports = __webpack_public_path__ + "img/time_line_circular_connect_head_title.4c2b9ebf.svg";